import React from 'react'
import TrackAwait from 'AccountsIcons/time.svg'
import TrackDone from 'AccountsIcons/tick.svg'
import TrackFail from 'AccountsIcons/cross.svg'
import TrackIdle from 'SVGPath/track-idle.svg'
import CountdownTimer from './CountdownTimer'

const trackIcons = [
  <TrackAwait fill="#339902" />,
  <TrackDone fill="#339902" />,
  <TrackFail fill="#ff3b30" />
]

const statusClass = ['', 'active-tag', '']
// eslint-disable-next-line complexity
const TrackerStep = ({
  active,
  status,
  msg,
  commonMsg,
  dueDate,
  tag,
  first,
  isPWA,
  last,
  dueMsgs
}) => {
  let activeClass = (active && status && statusClass[status]) || (status === null && 'c-grey-30')
  activeClass = activeClass || ''
  return (
    <li className={`${isPWA ? '' : 'flex-1'}`}>
      <div
        className={`flex
      ${!isPWA ? 'flex-column py-4' : 'py-2'}
      ${!isPWA && first ? 'flex-start' : ''}
      ${!isPWA && last ? 'flex-end' : ''}
        ${!isPWA && !last && !first ? 'flex-center' : ''}`}
      >
        <div
          className={`${!isPWA ? 'flex' : ''}
      ${!isPWA && first ? 'flex-start' : ''}
      ${!isPWA && last ? 'flex-end' : ''}
      ${!last ? 'tracker-icon-mob' : ''}
      ${!isPWA ? '' : 'pr-2'}
      ${!isPWA && !last && !first ? ' flex-center' : ''}`}
        >
          <If condition={status}>
            {trackIcons[status]}
            <Else />
            <If condition={isPWA}>
              <TrackIdle />
            </If>
          </If>
        </div>
        <div className={`flex-1 ${!isPWA || last ? '' : 'pb-4 border-bottom-grey'}`}>
          <div className="flex flex-between">
            <p
              className={`${isPWA ? 'fs-15' : 'fs-caption-2 pt-1'}
          ${!isPWA && first ? 'ta-left' : ''}
      ${!isPWA && last ? 'ta-right' : ''}
      ${!isPWA && !last && !first ? ' ta-center' : ''} ${activeClass}`}
            >
              {tag}
            </p>
            <If condition={dueDate && status === '0'}>
              <CountdownTimer dueDate={dueDate} isPWA={isPWA} />
            </If>
          </div>
          <If condition={dueMsgs && dueMsgs.length > 0}>
            <p
              className={`${isPWA ? 'fs-13' : 'fs-caption-2'} tt-sentence ${
                status ? 'color-8a' : 'c-grey-30'
              } pt-1`}
            >
              {dueMsgs.join(' ')}
            </p>
          </If>
          <If condition={msg && msg.length > 0}>
            {msg.map(item => (
              <p
                className={`${isPWA ? 'fs-13' : 'fs-caption-2'} tt-sentence ${
                  status ? 'color-8a' : 'c-grey-30'
                } pt-1`}
              >
                {item}
              </p>
            ))}
          </If>
          <If condition={commonMsg && commonMsg.length > 0 && active}>
            {commonMsg.map(item => (
              <p
                className={`${isPWA ? 'fs-13' : 'fs-caption-2'} ${
                  status ? 'color-8a' : 'c-grey-30'
                } pt-1`}
              >
                {item}
              </p>
            ))}
          </If>
        </div>
      </div>
    </li>
  )
}
export default TrackerStep
